export const ONE_DAY_AGO = new Date().getTime() - 24*3600*1000;
export const TWO_YEAR_AGO = new Date().getTime() - 2*365*24*3600*1000;

const longDatetime = Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23', timeZone: 'UTC'})
const numberFormat = new Intl.NumberFormat('en-US')

export const isActive = (project) => {
    return Date.parse(project.lastSchedulerOnline) > ONE_DAY_AGO && (Date.parse(project.lastWorkAvailable) > ONE_DAY_AGO || !project.hasServerStatusPage);
}

export const isLowWork = (project) => {
    return Date.parse(project.lastSchedulerOnline) > ONE_DAY_AGO && (Date.parse(project.lastWorkAvailable) < ONE_DAY_AGO && project.hasServerStatusPage);
}

export const isUnavailable = (project) => {
    return Date.parse(project.lastSuccess) < ONE_DAY_AGO && !isActive(project) && !isLowWork(project);
}

export const isInactive = (project) => {
    return !isLowWork(project) && !isUnavailable(project) && !isActive(project)
}

export const projectsWithNews = (projects) => {
    return projects.filter( (project) => {
        return Date.parse(project.lastNews) > TWO_YEAR_AGO;
    })
}

export const sortProjects = (projects, sort) => {
    return projects.sort((a,b) => {
        return sort(a,b)
    })
}

export const sortByName = (a,b) => {
    return a.name.localeCompare(b.name)
}

export const sortByUsers = (a,b) => {
    return b.numActiveUsers - a.numActiveUsers
}

export const sortByHosts = (a,b) => {
    return b.numActiveHosts - a.numActiveHosts
}

export const sortByJobs = (a,b) => {
    return b.resultsReadyToSend - a.resultsReadyToSend
}

export const sortByLastNews = (a,b) => {
    const aDate = new Date(a.lastNews)
    const bDate = new Date(b.lastNews)
    return bDate.getTime() - aDate.getTime()
}

export const formatLongDate = (date) => {
    return longDatetime.format(date) + ' UTC'
}

export const formatNumber = (value) => {
    return numberFormat.format(value)
}